import type { AxiosError } from 'axios';
import { app } from '@/main';

import alertIcon from '@/assets/i/alert.svg';

export const errorToast = (message: string) => {
  app.config.globalProperties.$dctoast.add({
    position: 'right-bottom',
    content: message,
    timeout: 10,
    color: 'red',
    icon: alertIcon,
    closable: false,
    type: 'error'
  });
};

export const successToast = (message: string) => {
  app.config.globalProperties.$dctoast.add({
    position: 'right-bottom',
    content: message,
    timeout: 10,
    color: 'green-dark',
    closable: false,
    type: 'success'
  });
};

export const axiosErrorToast = (error: AxiosError<any>, errorMessage: string) => {
  const data = error.response?.data;
  const msg = data?.message?.replace(/\n/g, '<br />');
  errorToast(msg || errorMessage);
};
